import {
  BulkMarkTeacherPaymentAsSentFailureReason,
  bulkMarkTeacherPaymentAsSentFailureReasonToLabel,
  BulkMarkTeacherPaymentAsSentSummary,
} from '@airreading/common/data';

type Props = {
  response: BulkMarkTeacherPaymentAsSentSummary;
};

export const BuildMarkAsSentToastResponse = ({ response }: Props) => {
  const success = response.results.length;

  const failuresByReason = response.failures.reduce<Record<BulkMarkTeacherPaymentAsSentFailureReason, string[]>>(
    (acc, { id, reason }) => {
      if (!acc[reason]) {
        acc[reason] = [];
      }
      acc[reason].push(id);
      return acc;
    },
    {} as Record<BulkMarkTeacherPaymentAsSentFailureReason, string[]>,
  );

  return (
    <div className="flex flex-col">
      {success !== 0 && <span>✅ {success} selected records were successfully marked as Sent.</span>}
      {Object.entries(failuresByReason).map(([reason, ids]) => (
        <span key={reason}>
          {(reason as BulkMarkTeacherPaymentAsSentFailureReason) === 'unknown' ? (
            <>❌ {ids.length} records could not be marked as Sent</>
          ) : (
            <>
              💳 {ids.length} records could not be marked as Sent due to{' '}
              {bulkMarkTeacherPaymentAsSentFailureReasonToLabel[reason as BulkMarkTeacherPaymentAsSentFailureReason]}
            </>
          )}
        </span>
      ))}
    </div>
  );
};
